<template>
  <label class="c-checkbox" :class="[{ 'flex': this.stacked, 'inline-flex mr-4': !this.stacked, 'c-checkbox--is-switch': this.switch, 'c-checkbox--is-valid': state === true,  'c-checkbox--is-invalid': state === false }]">
    <input type="checkbox" autocomplete="off" :name="name" v-model="localValue" class="c-checkbox__input mousetrap" :disabled="disabled">
    <span class="c-checkbox__check"></span>
    <span class="c-checkbox__label"><slot /></span>
  </label>
</template>

<script>
  export default {
    name: 'BaseCheckbox',

    model: {
      prop: 'checked',
      event: 'change'
    },

    props: {
      checked: {
        type: Boolean,
        default: null
      },
      name: {
        type: String,
        required: false
      },
      state: {
        type: [Boolean, null],
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: Boolean,
        default: false
      },
      switch: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      localValue: {
        get () {
          return this.checked
        },
        set (value) {
          this.$emit('change', value)
        }
      }
    }
  }
</script>
